import { el } from './dom';
import { i18n } from './i18n/i18n';
import type { Locale } from './i18n/dictionaries';

const FLAGS: Record<Locale, string> = {
  es: '🇪🇸',
  de: '🇩🇪',
  pt: '🇵🇹',
  it: '🇮🇹',
};

/**
 * Renderiza el selector de idioma como un select.
 * Cuando cambia el idioma, llama a `onChange` (típicamente para re-renderizar la vista).
 */
export function buildLanguageSelector(onChange: () => void): HTMLElement {
  const wrapper = el('div', { className: 'lang-selector' });
  const select = document.createElement('select');
  select.className = 'btn-logout';
  select.setAttribute('aria-label', 'Language');

  for (const locale of i18n.getSupportedLocales()) {
    const opt = document.createElement('option');
    opt.value = locale;
    opt.textContent = `${FLAGS[locale]} ${locale.toUpperCase()}`;
    if (locale === i18n.getLocale()) opt.selected = true;
    select.appendChild(opt);
  }

  select.addEventListener('change', () => {
    i18n.setLocale(select.value as Locale);
    onChange();
  });

  wrapper.appendChild(select);
  return wrapper;
}
